/* qeslint-disable */
// q@ts-nocheck

import { HomeButton, OrthographicFrustum, Viewer } from "cesium";

import "./NavigationControlbar.css";
import { CesiumFPVCameraController } from "./CesiumFPVCameraController";
import { CesiumFLYCameraController } from "./CesiumFLYCameraController";
import { construktedApi } from "./ConstruktedApi";

function newButton(tooltipText: string, iconClass: string, text: string = "") {
    const button = document.createElement("button");
    const icon = document.createElement("i");

    icon.className = iconClass;

    button.type = "button";
    button.innerHTML = icon.outerHTML + text;
    button.className = "construkted-viewer-controlbar-button";
    button.setAttribute("title", tooltipText);

    return button;
}

function getFirstElementByClass<T extends Element>(className: string) {
    return document.getElementsByClassName(className)[0] as T | undefined;
}

function changeMainIcon(container: string, iconClass: string) {
    // Get the element that has the container class
    const element = getFirstElementByClass<HTMLElement>(container);
    const button = element?.getElementsByClassName("construkted-viewer-controlbar-selectedElement")[0] as
        | HTMLElement
        | undefined;

    if (!button) {
        console.warn(`changeMainIcon: missing target button for container "${container}"`);

        return;
    }

    button.innerHTML = `<i class="${iconClass}"></i>`;
}

function wrapInSelector(
    element: HTMLElement,
    selector: string,
    icon: string = "icon-layers",
    text: string = "",
    tooltip: string = ""
) {
    const wrapper = document.createElement("div");

    // Add the selected element (first argument) to the wrapper
    const selectedElement = document.createElement("button");

    selectedElement.className = "construkted-viewer-controlbar-selectedElement construkted-viewer-controlbar-button";

    selectedElement.innerHTML = `<i class="${icon}"></i> ${text}`;

    // Set the tooltip/title of the selected element
    if (tooltip !== "") {
        selectedElement.setAttribute("title", tooltip);
    }

    // Create the wrapper for the options
    const optionsWrapper = document.createElement("div");

    optionsWrapper.className = "construkted-viewer-controlbar-optionsWrapper";

    wrapper.className = selector;
    optionsWrapper.appendChild(element);

    wrapper.appendChild(selectedElement);
    wrapper.appendChild(optionsWrapper);

    return wrapper;
}

interface ConstructorOptions {
    viewer: Viewer;
    container: HTMLElement;
    createViewMode: boolean;
    fpvController: CesiumFPVCameraController;
    flyController: CesiumFLYCameraController;
}

class NavigationControlbar {
    private _fpvController: CesiumFPVCameraController;
    private _flyController: CesiumFLYCameraController;

    private _container: HTMLElement;

    constructor(options: ConstructorOptions) {
        const container = options.container;
        const scene = options.viewer.scene;

        this._fpvController = options.fpvController;
        this._flyController = options.flyController;

        const fpvButton = newButton("FPV", "gwicon-user");
        const flyButton = newButton("FLY", "gwicon-baloon");
        const orbitButton = newButton("ORBIT", "gwicon-orbit");

        orbitButton.classList.add("active");

        const viewContainer = document.createElement("div");

        viewContainer.className = "construkted-viewer-viewController";

        viewContainer.appendChild(fpvButton);
        viewContainer.appendChild(flyButton);
        viewContainer.appendChild(orbitButton);

        fpvButton.addEventListener("click", () => {
            const frustum = construktedApi.getCameraFrustum();

            if (!frustum) {
                console.warn("fpvButton click: camera frustum not available");

                return;
            }

            if (frustum instanceof OrthographicFrustum) {
                console.warn("fpv disabled!");

                return;
            }

            fpvButton.classList.add("active");
            orbitButton.classList.remove("active");
            flyButton.classList.remove("active");

            const flyNavigation = getFirstElementByClass<HTMLElement>("fly-navigation");

            if (flyNavigation) {
                flyNavigation.classList.add("hidden");
            } else {
                console.warn("fpvButton click: .fly-navigation element not found");
            }

            if (this._fpvController.started()) {
                return;
            }

            if (this._flyController.started()) {
                this._flyController.stop();
            }

            this._fpvController.setAllowCheckingStart(true);

            changeMainIcon("navigation-options", "gwicon-user");

            jQuery("#camera-switcher").prop("disabled", true);
        });

        flyButton.addEventListener("click", () => {
            const frustum = construktedApi.getCameraFrustum();

            if (!frustum) {
                console.warn("flyButton click: camera frustum not available");

                return;
            }

            if (frustum instanceof OrthographicFrustum) {
                console.warn("fly disabled!");

                return;
            }

            fpvButton.classList.remove("active");
            orbitButton.classList.remove("active");
            flyButton.classList.add("active");

            const flyNavigation = getFirstElementByClass<HTMLElement>("fly-navigation");

            if (flyNavigation) {
                flyNavigation.classList.remove("hidden");
            } else {
                console.warn("flyButton click: .fly-navigation element not found");
            }

            if (this._flyController.started()) {
                console.warn("already started");

                return;
            }

            if (this._fpvController.started()) {
                this._fpvController.exitFPV();
            }

            this._fpvController.setAllowCheckingStart(false);

            this._flyController.start();

            changeMainIcon("navigation-options", "gwicon-baloon");

            jQuery("#camera-switcher").prop("disabled", true);
        });

        orbitButton.addEventListener("click", () => {
            const flyNavigation = getFirstElementByClass<HTMLElement>("fly-navigation");

            if (flyNavigation) {
                flyNavigation.classList.add("hidden");
            } else {
                console.warn("orbitButton click: .fly-navigation element not found");
            }

            fpvButton.classList.remove("active");
            orbitButton.classList.add("active");

            flyButton.classList.remove("active");

            if (this._fpvController.started()) {
                this._fpvController.exitFPV();
            } else if (this._flyController.started()) {
                this._flyController.stop();
            } else {
                // do nothing
            }

            this._fpvController.setAllowCheckingStart(false);

            changeMainIcon("navigation-options", "gwicon-orbit");

            jQuery("#camera-switcher").prop("disabled", false);
        });

        const navOptions = wrapInSelector(
            viewContainer,
            "container-options navigation-options",
            "gwicon-orbit",
            "",
            "Navigation"
        );

        // Add the navigation buttons
        container.appendChild(navOptions);

        const createViewMode = options.createViewMode;

        if (createViewMode) {
            // Create and add the view mode buttons
            const button3d = newButton("3D Mode", "gwicon-3d-1");
            const button2d = newButton("2D Mode", "gwicon-2d");
            const button2dn = newButton("2DN Mode", "gwicon-2dn");

            button3d.classList.add("active");

            button3d.addEventListener("click", () => {
                button3d.classList.add("active");
                button2d.classList.remove("active");
                button2dn.classList.remove("active");
                construktedApi.set3DViewMode();
                changeMainIcon("view-options", "gwicon-3d-1");
            });

            button2d.addEventListener("click", () => {
                button2d.classList.add("active");
                button3d.classList.remove("active");
                button2dn.classList.remove("active");
                construktedApi.set2DViewMode();
                changeMainIcon("view-options", "gwicon-2d");
            });

            button2dn.addEventListener("click", () => {
                button2dn.classList.add("active");
                button3d.classList.remove("active");
                button2d.classList.remove("active");
                construktedApi.set2DNorthUpViewMode();
                changeMainIcon("view-options", "gwicon-2dn");
            });

            const viewModeContainer = document.createElement("div");

            viewModeContainer.className = "construkted-viewer-controlbar-viewmode-container";

            viewModeContainer.appendChild(button3d);
            viewModeContainer.appendChild(button2d);
            viewModeContainer.appendChild(button2dn);

            const viewOptions = wrapInSelector(
                viewModeContainer,
                "container-options view-options",
                "gwicon-3d-1",
                "",
                "View Mode"
            );

            document.getElementsByClassName("construkted-viewer-controlbarContainer")[0]?.appendChild(viewOptions);
        }

        const modelWireframeButton = newButton("Model Wireframe", "gwicon-wireframe", "Model Wireframe");
        const modelShadedButton = newButton("Model Shaded", "gwicon-shaded", "Model Shaded");
        const modelTextureButton = newButton("Model Textured", "gwicon-textured", "Model Textured");

        modelTextureButton.classList.add("active");

        // Create the model shading buttons
        const modelModeContainer = document.createElement("div");

        modelModeContainer.className = "construkted-viewer-controlbar-modelmode-container";

        modelWireframeButton.addEventListener("click", () => {
            modelWireframeButton.classList.add("active");
            modelShadedButton.classList.remove("active");
            modelTextureButton.classList.remove("active");
            construktedApi.setWireframeShadingMode();
        });

        modelShadedButton.addEventListener("click", () => {
            modelShadedButton.classList.add("active");
            modelWireframeButton.classList.remove("active");
            modelTextureButton.classList.remove("active");
            construktedApi.setSolidShadingMode();
        });

        modelTextureButton.addEventListener("click", () => {
            modelTextureButton.classList.add("active");
            modelWireframeButton.classList.remove("active");
            modelShadedButton.classList.remove("active");
            construktedApi.setTextureShadingMode();
        });

        modelModeContainer.appendChild(modelWireframeButton);
        modelModeContainer.appendChild(modelShadedButton);
        modelModeContainer.appendChild(modelTextureButton);

        const modelOptions = wrapInSelector(
            modelModeContainer,
            "container-options model-options",
            "gwicon-desktop",
            "",
            "Model Shading"
        );

        document.getElementsByClassName("construkted-viewer-controlbarContainer")[0]?.appendChild(modelOptions);

        // Add the help and home buttons
        const helpButton = newButton("", "icon-help");

        helpButton.classList.remove("construkted-viewer-controlbar-button");
        helpButton.classList.add("active", "viewer-help-button");
        helpButton.setAttribute("title", "Help");

        helpButton.addEventListener("click", () => {
            jQuery(".ck-asset-modal").removeClass("hidden is-closed");
            jQuery(".ck-asset-modal").fadeIn(300);
        });

        container.appendChild(helpButton);

        // Add the home button
        // eslint-disable-next-line no-new
        new HomeButton(container, scene, 1.5);

        const layersPanelToggleButton = newButton("Layers", "gwicon-layers");

        layersPanelToggleButton.addEventListener("click", () => {
            construktedApi.showLayersPanel();
        });

        container.appendChild(layersPanelToggleButton);

        this._container = container;
    }

    show() {
        this._container.style.display = "block";
    }

    hide() {
        this._container.style.display = "none";
    }
}

export { NavigationControlbar };
